import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { getAvailableOperators, getFieldById } from "@/lib/override-rules";
import type { ConditionalRuleDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";

interface OperatorSelectorProps {
  value: ConditionalRuleDto["operator"];
  onChange: (value: ConditionalRuleDto["operator"]) => void;
  fieldId: string;
  placeholder?: string;
  disabled?: boolean;
}

export function OperatorSelector({
  value,
  onChange,
  fieldId,
  placeholder = "Choose operator",
  disabled,
}: OperatorSelectorProps) {
  const t = useTranslation();

  const field = getFieldById(fieldId);
  const availableOperators = field ? getAvailableOperators(field.type) : [];

  return (
    <Select
      value={
        availableOperators.map((op) => op.value).includes(value)
          ? value
          : undefined
      }
      onValueChange={onChange}
      disabled={disabled || !field}
    >
      <SelectTrigger
        className="h-8 min-w-[4rem] max-w-fit overflow-hidden text-ellipsis"
        title={t(`overrideRules.operators.${value}.description`)}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {availableOperators.map((operator) => (
          <SelectItem
            key={operator.value}
            value={operator.value}
            title={t(`overrideRules.operators.${operator.value}.description`)}
          >
            {t(`overrideRules.operators.${operator.value}.label`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
